module.exports = __webpack_public_path__ + "static/Forecast-db3f05de4b714cac6e5a07ca6cfdcbee.png";